export default {
  'dv.title.mem': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'dv.title.db.resp.time': {
    ko: 'Response Time',
    ja: '応答時間',
    en: 'Response Time',
  },
  'dv.title.tqo': {
    ko: 'tRFC Outbound',
    ja: 'tRFCアウトバウンド',
    en: 'tRFC Outbound',
  },
  'dv.set.tnim.more.np': {
    ko: '더이전/더이후 이동 간격 설정',
    ja: 'もっと前へ/もっと後への移動間隔を設定',
    en: 'Set the upper interval for moving',
  },
  'dv.set.tnim.np': {
    ko: '이전/이후 이동 간격 설정',
    ja: '前へ/後への移動間隔を設定',
    en: 'Set the lower interval for moving',
  },
  'dv.info.tnim.gt.max': {
    ko: '이동 간격의 최대값이 {max}보다 클 수 없습니다.',
    ja: '移動間隔の最大値は{max}を超えることはできません。',
    en: 'Maximum value of interval for moving is not able to be greater than {max}',
  },
  'dv.title.ntwk': {
    ko: 'Network',
    ja: 'ネットワーク',
    en: 'Network',
  },
  'dv.title.buffer': {
    ko: 'SAP Buffer',
    ja: 'SAPバッファ',
    en: 'SAP Buffer',
  },
  'dv.title.db.memory': {
    ko: 'Memory',
    ja: 'メモリ',
    en: 'Memory',
  },
  'dv.title.cpu': {
    ko: 'CPU',
    ja: 'CPU',
    en: 'CPU',
  },
  'dv.title.enq': {
    ko: 'Enqueue Lock',
    ja: 'エンキューロック',
    en: 'Enqueue Lock',
  },
  'dv.title.upd': {
    ko: 'Update Record',
    en: 'Update Record',
    ja: 'レコード更新',
  },
  'dv.title.upd.error': {
    ko: 'Upd. Record (Error)',
    en: 'Upd. Record (Error)',
    ja: 'レコード更新 (Error)',
  },
  'dv.title.workprcs': {
    ko: 'Work Process',
    ja: 'ワークプロセス',
    en: 'Work Process',
  },
  'dv.info.tnim.lt.min': {
    ko: '이동 간격의 최소값이 {min}보다 적을 수 없습니다.',
    ja: '移動間隔の最小値は{min}未満にはできません。',
    en: 'Minimal value of interval for moving is not able to be less than {min}',
  },
  'dv.title.db.locks': {
    ko: 'Locks',
    ja: 'ロック',
    en: 'Locks',
  },
  // BEGIN::Removed.by.KWShin.2026.05.12
  // 굳이 dv.title.exc와 구분할 필요없어서 제거함.
  // 'dv.title.hana.lock': {
  //   ko: 'Exclusive Lock (HANA)',
  //   ja: 'エクスクルーシブロック(HANA)',
  //   en: 'Exclusive Lock (HANA)',
  // },
  // FINISH::Removed.by.KWShin.2026.05.12
  'dv.title.db.tblspace': {
    ko: 'Table space',
    ja: 'テーブルスペース',
    en: 'Table space',
  },
  'dv.title.fsys': {
    ko: 'File System',
    ja: 'ファイルシステム',
    en: 'File System',
  },
  'dv.title.prcs': {
    ko: 'Top Process',
    ja: 'トッププロセス',
    en: 'Top Process',
  },
  'dv.title.queue': {
    ko: 'Queue',
    ja: 'キュー',
    en: 'Queue',
  },
  'dv.title.sap.buffer': {
    ko: 'SAP Buffer',
    ja: 'SAP Buffer',
    en: 'SAP Buffer',
    cn: 'SAP Buffer',
  },
  'dv.title.sap.memory': {
    ko: 'SAP Memory',
    ja: 'SAP Memory',
    en: 'SAP Memory',
    cn: 'SAP Memory',
  },
  'dv.title.logon.group': {
    ko: 'Logon Group',
    ja: 'ログオングループ',
    en: 'Logon Group',
  },
  'dv.title.db.space': {
    ko: 'Space',
    ja: 'スペース',
    en: 'Sapce',
  },
  'dv.title.db.queries': {
    ko: 'Queries',
    ja: 'クエリー',
    en: 'Queries',
  },
  'dv.title.workprcs.type': {
    ko: 'Work Process Type',
    ja: 'ワークプロセスタイプ',
    en: 'Work Process Type',
  },
  'dv.set.cycle': {
    ko: '이동 간격 시간 설정',
    ja: '移動間隔の時間を設定',
    en: 'Set the term of interval for moving',
  },
  'dv.title.prcs.mem': {
    ko: 'SAP Memory',
    ja: 'SAPメモリ',
    en: 'SAP Memory',
  },
  'dv.title.sssn': {
    ko: 'Logon Session',
    ja: 'ログオンセッション',
    en: 'Logon Session',
  },
  'dv.title.dup': {
    ko: 'Logon ID Duplication',
    ja: 'ログオンIDの重複',
    en: 'Logon ID Duplication',
  },
  'dv.title.abap.dump': {
    ko: 'ABAP Dump',
    ja: 'ABAPダンプ',
    en: 'ABAP Dump',
  },
  'dv.title.disk': {
    ko: 'Disk I/O',
    ja: 'ディスクI/O',
    en: 'Disk I/O',
  },
  'dv.title.tqi': {
    ko: 'tRFC Inbound',
    ja: 'tRFCインバウンド',
    en: 'tRFC Inbound',
  },
  'dv.title.exc': {
    ko: 'Exclusive Lock',
    ja: 'エクスクルーシブロック',
    en: 'Exclusive Lock',
  },
  'dv.title.user': {
    ko: 'Logon User',
    ja: 'ログオンユーザー',
    en: 'Logon User',
  },
  // FINISH::Added.by.KWShin.2024.09.11.
  // BEGIN::Added.by.KWShin.2025.10.22.
  'dv.label.job.status': {
    ko: 'Job status',
    en: 'Job status',
  },
  // status에 값이 없는 경우
  'dv.job.status.undefined': {
    ko: '',
    en: '',
  },
  'dv.job.status.A': {
    ko: 'Canceled',
    en: 'Canceled',
  },
  'dv.job.status.F': {
    ko: 'Finished',
    en: 'Finished',
  },
  'dv.job.status.P': {
    ko: 'Scheduled',
    en: 'Scheduled',
  },
  'dv.job.status.R': {
    ko: 'Active',
    en: 'Active',
  },
  'dv.job.status.S': {
    ko: 'Released',
    en: 'Released',
  },
  'dv.job.status.Y': {
    ko: 'Ready',
    en: 'Ready',
  },
  'dv.label.after.event': {
    ko: 'After event',
    en: 'After event',
  },
  'dv.label.job.nm': {
    ko: 'Job name',
    en: 'Job name',
  },
  'dv.hint.job.nm': {
    ko: "Job name ('%' 허용)",
    en: "Job name (with '%')",
  },
  'dv.label.user.nm': {
    ko: '사용자 ID',
    en: 'User name',
  },
  'dv.hint.user.nm': {
    ko: "사용자 ID ('%' 허용)",
    en: "User name (with '%')",
  },
  'dv.label.job.step': {
    ko: 'Job step',
    en: 'Job step',
  },
  'dv.hint.job.step': {
    ko: "ABAP Program name ('%' 허용)",
    en: "ABAP Program name (with '%')",
  },
  'dv.ttl.job.list': {
    ko: '배치잡 목록',
    en: 'Job list',
  },
  'dv.field.job.nm': {
    ko: '배치잡 명',
    en: 'Job name',
  },
  'dv.field.sdl.uname': {
    ko: '생성자',
    en: 'Creator',
  },
  'dv.field.job.status': {
    ko: '상태',
    en: 'Status',
  },
  'dv.field.sdlstrt.ymdhms': {
    ko: '시작일시',
    en: 'Start date/time',
  },
  'dv.field.job.duration': {
    ko: '경과시간 (sec.)',
    en: 'Duration (sec.)',
  },
  'dv.field.job.delay': {
    ko: '지연시간 (sec.)',
    en: 'Delay (sec.)',
  },
  'dv.ttl.job.detail': {
    ko: '배치잡 상세',
    en: 'Job detail',
  },
  'dv.ttl.job.log': {
    ko: '배치잡 로그',
    en: 'Job log',
  },
  'dv.field.enter.ymdhms': {
    ko: '로그 일시',
    en: 'Enter date/time',
  },
  'dv.field.job.log.text': {
    ko: '메시지',
    en: 'Message',
  },
  'dv.field.msg.id': {
    ko: '메시지 클래스',
    en: 'Message class',
  },
  'dv.field.msg.no': {
    ko: '메시지 No.',
    en: 'Message no.',
  },
  'dv.field.msg.type': {
    ko: '메시지 유형',
    en: 'Message type',
  },
  'dv.ttl.job.step': {
    ko: '배치잡 스텝',
    en: 'Job step',
  },
  'dv.field.step.count': {
    ko: 'No.',
    en: 'No.',
  },
  'dv.field.entry.id': {
    ko: 'Program name/Command',
    en: 'Program name/Command',
  },
  'dv.field.account': {
    ko: '사용자',
    en: 'User',
  },
  'dv.field.respti': {
    ko: 'R.T.',
    en: 'R.T.',
  },
  'dv.field.db.time': {
    ko: 'DB time',
    en: 'DB time',
  },
  'dv.field.memsum': {
    ko: '메모리',
    en: 'Memory',
  },
  'dv.ttl.general.data': {
    ko: '일반',
    en: 'General data',
  },
  'dv.field.job.name': {
    ko: 'Job name',
    en: 'Job name',
  },
  'dv.field.job.class': {
    ko: 'Job class',
    en: 'Job class',
  },
  'dv.field.exec.trgt': {
    ko: '실행 타겟',
    en: 'Exec. target',
  },
  'dv.ttl.job.start': {
    ko: '일정',
    en: 'Job start',
  },
  'dv.field.planned.start': {
    ko: '실행 일정',
    en: 'Planned start',
  },
  'dv.field.every.month': {
    ko: '매월',
    en: 'Monthly',
  },
  'dv.field.every.week': {
    ko: '매주',
    en: 'Weekly',
  },
  'dv.field.every.day': {
    ko: '매일',
    en: 'dayiy',
  },
  'dv.field.every.hour': {
    ko: '매시간',
    en: 'Hourly',
  },
  'dv.field.every.minute': {
    ko: '매분',
    en: 'Minutely',
  },
  'dv.field.no.start.after': {
    ko: '일정 종료',
    en: 'No Start after',
  },
  'dv.ttl.job.frequency': {
    ko: '반복주기',
    en: 'Job frequency',
  },
  'dv.ttl.job.steps': {
    ko: 'Job steps',
    en: 'Job steps',
  },
  'dv.ttl.reg.pgm.mntr': {
    ko: '프로그램 모니터 등록/보기',
    en: 'Register/view program monitor',
  },
  // BEGIN::Added.by.KWShin.2026.09.18.
  // JOBNAME + AUTHCKMAN 이 겹치면 프로그램 모니터에 등록할 수 없다.
  'dv.msg.dup.batch.job.name': {
    ko: '주기적인 배치잡의 이름 중복은 SAP 권장 사항에서 벗어납니다.',
    ja: '定期バッチジョブ名の重複はSAPの推奨事項から外れます。',
    en: 'Duplicated names of periodic batch jobs deviate from the SAP recommendation.',
    cn: 'Duplicated names of periodic batch jobs deviate from the SAP recommendation.',
  },
  // FINISH::Added.by.KWShin.2026.09.18.
  'dv.job.chart.all.day.ttl': {
    ko: '배치잡 24 시간',
    en: 'Batch job all day',
  },
  'dv.job.chart.ttp.total': {
    ko: 'Total',
    en: 'Total',
  },
  'dv.job.chart.ttp.finish': {
    ko: 'Finished',
    en: 'Finished',
  },
  'dv.job.chart.ttp.cancel': {
    ko: 'Canceled',
    en: 'Canceled',
  },
  'dv.job.data.sync': {
    ko: 'View batch job data',
    en: 'View batch job data',
  },
  'dv.btn.to.cur.time': {
    ko: '현재 시각',
    en: 'Current time',
  },
  // FINISH::Added.by.KWShin.2025.10.22.
  // BEGIN::Added.by.KWShin.2025.11.24.
  'dv.title.eden.space': {
    ko: 'Eden Space',
    en: 'Eden Space',
  },
  'dv.title.survivor.space': {
    ko: 'Survivor Space',
    en: 'Survivor Space',
  },
  'dv.title.perm.gen': {
    ko: 'Permanent Generation',
    en: 'Permanent Generation',
  },
  'dv.title.tenured.gen': {
    ko: 'Tenured Generation',
    en: 'Tenured Generation',
  },
  // FINISH::Added.by.KWShin.2025.11.24.
  // BEGIN::Added.by.KWShin.2025.11.26.
  'dv.title.msg.svr': {
    ko: 'Message Server',
    en: 'Message Server',
  },
  'dv.title.enqueue.lock': {
    ko: 'Enqueue Lock',
    en: 'Enqueue Lock',
  },
  'dv.title.req.queue': {
    ko: 'ICM Request Queue',
    en: 'ICM Request Queue',
  },
  'dv.title.jdbc.conn': {
    ko: 'Jdbc Connection',
    en: 'Jdbc Connection',
  },
  'dv.title.trxn': {
    ko: 'Transaction',
    en: 'Transaction',
  },
  'dv.title.exclusive.lock': {
    ko: 'Exclusive Lock',
    en: 'Exclusive Lock',
  },
  'dv.title.http.sssn': {
    ko: 'HTTP Session',
    en: 'HTTP Session',
  },
  'dv.title.sstm.thrd': {
    ko: 'System Thread',
    en: 'System Thread',
  },
  'dv.title.app.thrd': {
    ko: 'Application Thread',
    en: 'Application Thread',
  },
  'dv.title.http.prvdr': {
    ko: 'HTTP Provider',
    en: 'HTTP Provider',
  },
  'dv.title.jsp.servlet': {
    ko: 'JSP / Servlet',
    en: 'JSP / Servlet',
  },
  'dv.title.rmi.p4': {
    ko: 'RMI-P4',
    en: 'RMI-P4',
  },
  'dv.title.svc.stts': {
    ko: 'Service Status',
    en: 'Service Status',
  },
  'dv.title.os.top.prcs': {
    ko: 'Top Process',
    en: 'Top Process',
  },
  'dv.title.os.cpu': {
    ko: 'CPU',
    en: 'CPU',
  },
  'dv.title.os.mem': {
    ko: 'Memory',
    en: 'Memory',
  },
  'dv.title.os.disk': {
    ko: 'Disk',
    en: 'Disk',
  },
  'dv.title.os.ntwk': {
    ko: 'Network',
    en: 'Network',
  },
  'dv.title.os.fsys': {
    ko: 'File System',
    en: 'File System',
  },
  // FINISH::Added.by.KWShin.2025.11.26.
};
